import { TextField } from '@mui/material';
import {NumberFormatCustom} from '../../widgets/formatter/NumberFormatter';
import IconButton from '@mui/material/IconButton';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';

type Props = {
    initial?: number,
    handleCommit: (value: number) => void,
    readonly?: boolean,
    label?: string,
    id?: string,
    layout?: string,
    max?: number
}

const CountInput = ({ initial, handleCommit, readonly, label, id, layout, max }: Props) => {
    const [remberInitial, setInitial] = React.useState<number | undefined>(initial);
    const [itemCount, setItemCount] = React.useState<string>(initial !== undefined ? String(initial) : '1');

    // We are synchronizing the local in-process editing state
    // vs. an externally tracked state. This gets funky.
    if (remberInitial !== initial) {
        setInitial(initial);
        setItemCount(initial !== undefined ? String(initial) : '1');
    }

    const atMax = max !== undefined && +itemCount >= max;

    const incrementCount = (event: React.MouseEvent<HTMLElement>) => {
        let count: number = +itemCount;
        if (count < 0) {
            count = 0;
        }
        count = count + 1;
        if (max !== undefined && count > max) {
            count = max;
        }
        setItemCount("" + count);
        handleCommit(count);
    };

    const decrementCount = (event: React.MouseEvent<HTMLElement>) => {
        let count: number = +itemCount;
        if (count < 0) {
            count = 0;
        }
        if (count > 0) {
            count = count - 1;
        }

        setItemCount("" + count);
        handleCommit(count);
    }

    const localHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value === undefined || value === '') {
            setItemCount('');
            return;
        }
        const intValue = +value;
        const useValue = intValue >= 0 ? value : '0';
        setItemCount(useValue);
    }

    const commitChange = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value ? event.target.value : '0';
        let intValue = +value;
        if (intValue < 0) {
            intValue = 0;
        }
        if (max !== undefined && intValue > max) {
            intValue = max;
        }
        setItemCount("" + intValue);
        handleCommit(intValue);
    }

    if (readonly) {
        return (<span className='count-input'>{itemCount}</span>)
    }

    return (
        <span className='count-input'>
            <div className='count-input-buttons'>
                <IconButton aria-label="plus one" size="small" onClick={incrementCount} disabled={atMax}>
                    <ArrowDropUpIcon />
                </IconButton>
                <IconButton aria-label="minus one" size="small" onClick={decrementCount}>
                    <ArrowDropDownIcon />
                </IconButton>
            </div>
            <TextField
                {...(label ? { label, InputLabelProps: { shrink: true } } : {})}
                value={itemCount}
                onChange={localHandleChange}
                onBlur={commitChange}
                name="numberformat"
                id={id ? id : "formatted-numberformat-input"}
                InputProps={{
                inputComponent: NumberFormatCustom as any,
            }}
            />
        </span>
    )
}

export default CountInput